// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "brand_example".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "brand_example" table (1:1 with a DB row, on the wire). */
export const brandExampleAtomSchema = z.object({
    id: z.string(),
    objectKey: z.string(),
    notes: z.string().nullable(),
    disabled: z.boolean(),
    lastUsedAt: z.string().datetime().nullable(),
    organizationId: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=brandExample.js.map